import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import Oauth from '../../oauth';
import ResaleTicketsBannerButton from './ResaleTicketsBannerButton';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import {
    shouldDisplayResaleButton,
    shouldDisplayLoginButton
} from './resale-tickets-banner-helpers';
import { addQueryParam, getOauthReturnUrl } from '../../../../../general/js/utils';
import { hasValue } from '../../../../../general/js/general-helpers';

class ResaleTicketsBanner extends Component {
    constructor(props) {
        super(props);
        this.handleTicketsResaleBuy = this.handleTicketsResaleBuy.bind(this);
        this.handleTicketsResaleSell = this.handleTicketsResaleSell.bind(this);
        this.getOauthResaleRedirectUri = this.getOauthResaleRedirectUri.bind(this);
    }

    handleTicketsLogin(event) {
        event.preventDefault();
        Oauth.getCurrentAuthenticatedUser()
            .then((user) => {
                if (!hasValue(user)) {
                    try {
                        Oauth.federatedSignIn();
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    window.location.reload();
                }
            })
            .catch(() => {
                try {
                    Oauth.federatedSignIn();
                } catch (error) {
                    console.error(error);
                }
            });
    }

    handleTicketsResaleBuy(event) {
        event.preventDefault();
        const { actions, resaleTicketSettings } = this.props;

        actions.handleRedirectToResaleTickets({
            resaleTicketsUrl: resaleTicketSettings.buyLink,
            secutixResaleUrl: resaleTicketSettings.secutixResaleUrl,
            secutixPointOfSaleId: resaleTicketSettings.secutixPointOfSaleId,
            secutixVirtualOperator: resaleTicketSettings.secutixVirtualOperator,
            redirectUri: this.getOauthResaleRedirectUri()
        });
    }

    getOauthResaleRedirectUri() {
        const { renderedComponent } = this.props;

        const returnUri = getOauthReturnUrl({
            useEncode: false
        });

        if (returnUri.includes('account/profile')) {
            return encodeURIComponent(addQueryParam(returnUri, 'componentToRender', renderedComponent));
        }

        return encodeURIComponent(returnUri);
    }

    handleTicketsResaleSell(event) {
        event.preventDefault();
        const { actions, resaleTicketSettings } = this.props;

        actions.handleRedirectToResaleTickets({
            resaleTicketsUrl: resaleTicketSettings.sellLink,
            secutixResaleUrl: resaleTicketSettings.secutixResaleUrl,
            secutixPointOfSaleId: resaleTicketSettings.secutixPointOfSaleId,
            secutixVirtualOperator: resaleTicketSettings.secutixVirtualOperator,
            redirectUri: this.getOauthResaleRedirectUri()
        });
    }

    render() {
        const {
            resaleTicketSettings,
            accountData,
            ctaLoginLabel,
            ctaLoginStyle,
            ctaFirstLabel,
            ctaFirstStyle,
            ctaSecondLabel,
            ctaSecondStyle
        } = this.props;

        const {
            sellButtonCriteria,
            buyButtonCriteria
        } = resaleTicketSettings;

        const ballotCriteria = isEmpty(accountData) ? null : accountData.attributes['custom:ballotCriteria'];
        const membership = isEmpty(accountData) ? null : accountData.attributes['custom:Membership'];

        const showLoginLink = shouldDisplayLoginButton(membership);
        const showBuyLink = shouldDisplayResaleButton(buyButtonCriteria, ballotCriteria, membership);
        const showSellLink = shouldDisplayResaleButton(sellButtonCriteria, ballotCriteria, membership);
        return (
            <Fragment>
                {showLoginLink &&
            <ResaleTicketsBannerButton onResaleClick = {this.handleTicketsLogin} buttonText= {ctaLoginLabel} buttonColor= {ctaLoginStyle}></ResaleTicketsBannerButton>}
                {showBuyLink &&
            <ResaleTicketsBannerButton onResaleClick = {this.handleTicketsResaleBuy} buttonText= {ctaFirstLabel} buttonColor={ctaFirstStyle}></ResaleTicketsBannerButton>}
                {showSellLink &&
            <ResaleTicketsBannerButton onResaleClick = {this.handleTicketsResaleSell} buttonText={ctaSecondLabel} buttonColor={ctaSecondStyle}></ResaleTicketsBannerButton>}
            </Fragment >
        );
    }
}

ResaleTicketsBanner.propTypes = {
    resaleTicketSettings: PropTypes.object.isRequired,
    ctaLoginLabel: PropTypes.string.isRequired,
    ctaLoginStyle: PropTypes.string.isRequired,
    ctaFirstLabel: PropTypes.string.isRequired,
    ctaFirstStyle: PropTypes.string.isRequired,
    ctaSecondLabel: PropTypes.string.isRequired,
    ctaSecondStyle: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            handleRedirectToResaleTickets: bindActionCreators(userAccountActions.handleRedirectToResaleTickets, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResaleTicketsBanner);
